import { markRaw } from 'vue';

// Static import map so Vite emits real production chunks.
// Avoid dynamic template imports with @vite-ignore — those request raw .vue
// files from the CDN and fail on deployed envs (e.g. mcom-189).
export const overlayLoaders = {
  associationJoinNow: () => import('../components/overlays/associationJoinNow.vue'),
  confirmRemove: () => import('../components/overlays/confirmRemove.vue'),
  earnRate: () => import('../components/overlays/earnRate.vue'),
  emailVerify: () => import('../components/overlays/emailVerify.vue'),
  exclusionsOverlay: () => import('../components/offers/ExclusionsOverlay.vue'),
  howItWorks: () => import('../components/overlays/howItWorks.vue'),
  infoExclusions: () => import('../components/overlays/infoExclusions.vue'),
  linkSuccessNotification: () => import('../components/overlays/linkSuccessNotification.vue'),
  loyaltyId: () => import('../components/overlays/loyaltyId.vue'),
  manageMembership: () => import('../components/overlays/manageMembership.vue'),
  negativePoints: () => import('../components/overlays/negativePoints.vue'),
  otpVerify: () => import('../components/overlays/otpVerify.vue'),
  pendingPoints: () => import('../components/overlays/pendingPoints.vue'),
  pickDateOverlay: () => import('../components/overlays/pickDateOverlay.vue'),
  removeDateOverlay: () => import('../components/overlays/removeDateOverlay.vue'),
  RewardsModal: () => import('../components/overlays/RewardsModal.vue'),
  termsCondition: () => import('../components/overlays/termsCondition.vue'),
  triplePointTooltipOverlay: () => import('../components/overlays/triplePointTooltipOverlay.vue'),
  triplePointUnusedTooltipOverlay: () => import('../components/overlays/triplePointUnusedTooltipOverlay.vue'),
};

/**
 * Resolve an overlay Vue component before opening the modal/slideout.
 * Awaiting the chunk first avoids an empty shell while defineAsyncComponent loads.
 */
export const loadOverlayComponent = async (name) => {
  const loader = overlayLoaders[name];
  if (!loader) {
    throw new Error(`Unknown overlay component: ${name}`);
  }
  const mod = await loader();
  return markRaw(mod.default ?? mod);
};
